import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ContatoPage } from "@/components/pages/ContatoPage";
import { dictionaries } from "@/i18n/dictionaries";
import {
  breadcrumbLd,
  contactPageLd,
  ldScripts,
} from "@/lib/seo-jsonld";

const SITE = "https://kentro.com.br";
const URL = `${SITE}/contato`;
const t = dictionaries.pt;

const contatoSearchSchema = z.object({
  src: z.string().optional(),
  vertical: z.string().optional(),
});

export const Route = createFileRoute("/contato")({
  validateSearch: (search) => {
    const r = contatoSearchSchema.safeParse(search);
    return r.success ? r.data : {};
  },
  head: () => ({
    meta: [
      { title: t.contactPage.metaTitle },
      { name: "description", content: t.contactPage.metaDesc },
      { property: "og:title", content: t.contactPage.metaTitle },
      { property: "og:description", content: t.contactPage.metaDesc },
      { property: "og:url", content: URL },
      { property: "og:locale", content: "pt_BR" },
    ],
    links: [
      { rel: "canonical", href: URL },
      { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/contato` },
      { rel: "alternate", hrefLang: "en", href: `${SITE}/en/contato` },
      { rel: "alternate", hrefLang: "es", href: `${SITE}/es/contato` },
      { rel: "alternate", hrefLang: "x-default", href: `${SITE}/contato` },
    ],
    scripts: ldScripts(
      breadcrumbLd([
        { name: "Início", path: "/" },
        { name: "Contato", path: "/contato" },
      ]),
      contactPageLd({
        url: URL,
        name: t.contactPage.metaTitle,
        description: t.contactPage.metaDesc,
        telephones: ["+55-0800-550-2020", "+55-11-91582-7716", "+55-38-3220-8706"],
        emails: ["contato@kentro.com.br"],
        contactType: "customer support",
      }),
    ),
  }),
  component: ContatoPage,
});
